<ng-template #helpPanel><deals-help-panel></deals-help-panel></ng-template>

<section class="deals-page">
    <div class="search-wrap">
        <search-bar [isFiltered]="isFiltered" (outEvent)="eventHandler($event)" label="Search by Jacket ID, Deal #, Customer, Co-Buyer, Vehicle or Dealer User">
        </search-bar>
    </div>
    <form class="management-filter-row">
        <div class="filters">
            <mat-form-field class="input" floatLabel="always">
                <mat-label>Filter by Category</mat-label>
                <mat-select placeholder="All" multiple [(value)]="selectedCategoryFilter" (selectionChange)="filterHandler($event)">
                    <mat-option [value]="option.value" *ngFor="let option of JacketCategoryOptions">{{ displayCategory(option.key) }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="actions">
            <div class="align-mobile">
                <mat-slide-toggle [checked]="isTableView" (change)="onToggleChanged($event)">
                    <mat-icon [matTooltip]="isTableView ? 'Card View' : 'Table View'" class="table-icon">{{
                        isTableView ? 'view_agenda' : 'view_list'
                    }}</mat-icon>
                </mat-slide-toggle>
                <button class="primary" mat-button aria-label="start deal jacket" [routerLink]="['/dashboard', 'deals', 'create']">Start Deal Jacket</button>
            </div>
        </div>
    </form>

    <div *ngIf="selectedCategoryFilter?.includes(DealStatuses.Deleted) || selectedCategoryFilter?.length === 0" class="important-note">
        <p>IMPORTANT: Deleted jackets will be retained for 60 days and can be restored during that time. After that, they will be permanently deleted.</p>
    </div>

    <div *ngIf="!isTableView" [style]="isLoading ? 'background-color: #ffffff50' : ''" class="deals-container">
        <div *ngIf="isLoading" class="loader-wrap">
            <three-dot-loader></three-dot-loader>
        </div>

        <div *ngIf="!isLoading">
            <ng-container *ngIf="deals.length > 0">
                <div class="deals">
                    <dealer-deal-card style="display: flex" *ngFor="let deal of deals" [deal]="deal"> </dealer-deal-card>
                </div>
            </ng-container>
        </div>
    </div>

    <!--BELOW IS TABLE VIEW-->

    <div *ngIf="isTableView" class="overflow">
        <table mat-table [dataSource]="dataSource" (matSortChange)="announceSortChange($event)" matSort class="mat-elevation-z8">
            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef sorted mat-sort-header sortActionDescription="Sort by Status">Category</th>
                <td style="padding-left: 1.8em" mat-cell *matCellDef="let element">
                    <span>{{ displayCategory(DealStatuses[element?.statusId]) }}</span>
                </td>
            </ng-container>
            <ng-container matColumnDef="jacketId">
                <th mat-header-cell *matHeaderCellDef sorted mat-sort-header sortActionDescription="Sort by Jacket ID">Jacket ID</th>
                <td mat-cell *matCellDef="let element">
                    <span>{{ element?.dealId }}</span>
                </td>
            </ng-container>
            <ng-container matColumnDef="dealNumber">
                <th mat-header-cell *matHeaderCellDef sorted mat-sort-header sortActionDescription="Sort by Jacket ID">Deal #</th>
                <td mat-cell *matCellDef="let element">
                    <span>{{ element?.dealerDealNumber }}</span>
                </td>
            </ng-container>
            <ng-container matColumnDef="customer">
                <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by Customer" sorted mat-sort-header>Customer</th>
                <td mat-cell *matCellDef="let element">
                    <span>{{ element.buyer?.firstName }} {{ element?.buyer?.lastName }}</span> <br />
                    <span>{{ element.buyer?.email }}</span> <br />
                    <span>{{ element.buyer?.phone }}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="coBuyer">
                <th mat-header-cell *matHeaderCellDef sorted mat-sort-header sortActionDescription="Sort by Co-Buyer">Co-Buyer</th>
                <td mat-cell *matCellDef="let element">
                    <span *ngIf="!element?.coBuyer?.firstName">N/A</span>
                    <ng-container>
                        <span>{{ element?.coBuyer?.firstName }} {{ element?.coBuyer?.lastName }}</span> <br />
                        <span>{{ element?.coBuyer?.email ?? '' }}</span> <br />
                        <span>{{ element?.coBuyer?.phone ?? '' }}</span>
                    </ng-container>
                </td>
            </ng-container>

            <ng-container matColumnDef="vehicle">
                <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by Vehicle" sorted mat-sort-header>Vehicle</th>
                <td mat-cell *matCellDef="let element">
                    <div *ngIf="element?.vehicle?.year && element?.vehicle?.year && element?.vehicle?.model">
                        <span>{{ element?.vehicle?.year }} {{ element?.vehicle?.make }} {{ element?.vehicle?.model }}</span> <br />
                        <span>{{ element?.vehicle?.vin }}</span> <br />
                        <span>{{ element?.vehicle?.stockNumber }}</span>
                    </div>
                    <div *ngIf="!element?.vehicle?.year && !element?.vehicle?.year && !element?.vehicle?.model">
                        <span>N/A</span>
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="createDate">
                <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by Details" sorted mat-sort-header>Key Details</th>
                <td mat-cell *matCellDef="let element">
                    <span>Date Created: {{ element?.createDate ? format('date', element.createDate.toString()) : 'N/A' }}</span> <br />
                    <span
                        >Created By: {{ element?.createdByUser?.firstName ? element.createdByUser.firstName + ' ' + element.createdByUser.lastName : 'N/A' }}
                    </span>
                    <br />
                    <span> Finance Manager: {{ 'N/A' }} </span>
                </td>
            </ng-container>

            <ng-container matColumnDef="actions" [stickyEnd]="true">
                <th mat-header-cell *matHeaderCellDef>
                    <div class="align-info">Actions</div>
                </th>
                <td mat-cell class="actions center" *matCellDef="let element">
                    <div *ngIf="hasEllipsisMenuAccess(element)" class="align-actions">
                        <button (click)="redirect(element)" mat-button class="primary small mobile-hidden">View Jacket</button>
                        <button mat-icon-button class="table-button" [matMenuTriggerFor]="actionsMenu" aria-label="Actions for row">
                            <mat-icon class="vert-icon">more_vert</mat-icon>
                        </button>
                    </div>
                    <mat-menu class="menu-actions" #actionsMenu="matMenu">
                        <div>
                            <button
                                *ngIf="isCategoryType([DealStatuses.Open], element.statusId)"
                                mat-menu-item
                                (click)="updateJacketStatus(element)"
                                [class.disabled]="!canClose(element)"
                                [disabled]="!canClose(element)"
                            >
                                Close Jacket
                            </button>
                        </div>
                        <div>
                            <button
                                *ngIf="isCategoryType([DealStatuses.Completed, DealStatuses.Archived], element.statusId)"
                                mat-menu-item
                                (click)="reopenJacketStatus(element)"
                                [class.disabled]="!canReopen(element)"
                                [disabled]="!canReopen(element)"
                            >
                                Reopen Jacket
                            </button>
                        </div>
                        <div>
                            <button
                                *ngIf="isCategoryType([DealStatuses.Completed], element.statusId)"
                                mat-menu-item
                                (click)="updateJacketStatus(element)"
                                [class.disabled]="!canArchive(element)"
                                [disabled]="!canArchive(element)"
                            >
                                Archive Jacket
                            </button>
                        </div>
                        <div *ngIf="canRestoreJacket(element, true)">
                            <button
                                *ngIf="isCategoryType([DealStatuses.Deleted], element.statusId) && hasDealDocumentsDelete"
                                mat-menu-item
                                (click)="dealRestore(element)"
                                [class.disabled]="!canRestoreJacket(element, true)"
                                [disabled]="!canRestoreJacket(element, true)"
                            >
                                Restore Jacket
                            </button>
                        </div>
                        <div *ngIf="hasDealDocumentsDelete">
                            <button
                                *ngIf="isCategoryType([DealStatuses.Open], element.statusId) && hasDealDocumentsDelete"
                                mat-menu-item
                                (click)="dealDelete(element)"
                                [class.disabled]="!canDeleteRequest(element)"
                                [disabled]="!canDeleteRequest(element)"
                            >
                                Delete Jacket
                            </button>
                        </div>
                    </mat-menu>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>

        <ddj-spinner *ngIf="isLoading"></ddj-spinner>
    </div>
    <div class="paginator-wrap">
        <ng-container *ngIf="totalNumberOfDeals > 0">
            <mat-paginator
                [length]="totalNumberOfDeals"
                [pageSize]="records"
                [pageSizeOptions]="[5, 10, 25, 100]"
                (page)="onPageChange($event)"
                [showFirstLastButtons]="true"
            >
            </mat-paginator>
        </ng-container>
    </div>
</section>
